// ================================================================
// 🎯 HOOK useI18n CORREGIDO - /src/hooks/useI18n.ts
// ================================================================

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

// ================================================================
// 🌍 TRADUCCIONES PARA TU SISTEMA
// ================================================================
const translations = {
  es: {
   
   wtsp: {
    title:"Atención WhatsApp Premium",
    subtitle:"Conecta directamente con nuestros técnicos especializados en motores Caterpillar. Atención personalizada las 24 horas, los 7 días de la semana.",
    diagnostic:"Diagnóstico Técnico",
    diagnosticsub:"Diagnóstico inmediato de problemas en motores Caterpillar",
    online:"En línea ahora",
    available:"12 técnicos disponibles • Tiempo de respuesta: < 2 minutos",
    repair: 'Guía de Reparación',
    repairsub:'Asistencia paso a paso para reparaciones',
    consultation:'Consultoría Especializada',
    consultationsub:'Sesión de consultoría con técnico senior',
    emergency:'Soporte de Emergencia',
    emergencysub:'Atención inmediata para problemas críticos',
    techs:'Técnicos Disponibles',
    timeprom:'Tiempo Promedio',
    satisfaction:'Satisfacción',
    disponibility:'Disponibilidad',
    }, 
   system: {
      online: "Sistema Online",
      offline: "Sistema Offline", 
      connecting: "Sistema Conectando...",
      lastCheck: "Última verificación:",
      never: "Nunca"
    },
    
    user: {
      greeting: "Hola, {{name}}"
    },
    
    theme: {
      switchToLight: "Cambiar a tema claro",
      switchToDark: "Cambiar a tema oscuro"
    },
    
    footer: {
      copyright: "Sistema Kikai © 2025 - Asistente Técnico Inteligente"
    },
    
     // ✅ AGREGAR ESTA SECCIÓN COMPLETA:
    billing: {
      title: "Facturación",
      subtitle: "Gestiona tu método de pago, plan actual e historial de facturas",
      
      // Plan actual
      plan: {
        name: "Plan Pro",
        type: "Mensual", 
        renewal: "Tu suscripción se renovará automáticamente el 5 oct 2025.",
        adjustPlan: "Ajustar plan"
      },
      
      // Método de pago
      payment: {
        title: "Pago",
        update: "Actualizar",
        noMethod: "No hay método de pago configurado",
        addMethod: "Agregar método de pago"
      },
      
      // Modal de pago
      modal: {
        title: "Método de pago",
        selectedPlan: "Plan Seleccionado"
      },
      
      // Formulario
      form: {
        fullName: "Nombre completo",
        fullNamePlaceholder: "Pedro Piedra",
        country: "País o región",
        address: "Primera línea de la dirección", 
        addressPlaceholder: "Av. Principal 123",
        cardNumber: "Número de tarjeta",
        expiryDate: "Fecha de vencimiento",
        securityCode: "Código de seguridad",
        taxId: "Número de identificación fiscal (Opcional)",
        taxIdHint: "Siempre que sea número de identificación fiscal, el \"nombre completo\" anterior debe ser el nombre de su empresa.",
        cancel: "Cancelar",
        update: "Actualizar",
        
        // Errores
        errors: {
          fullNameRequired: "Nombre completo es requerido",
          addressRequired: "Dirección es requerida",
          invalidCardNumber: "Número de tarjeta inválido",
          invalidExpiryDate: "Fecha de vencimiento inválida",
          invalidCVC: "Código de seguridad inválido",
          cardValidationError: "Error al validar la tarjeta"
        }
      },
      
      // Historial de facturas
      invoices: {
        title: "Facturas",
        date: "Fecha",
        total: "Total",
        status: "Estado",
        actions: "Acciones",
        view: "Ver",
        
        // Estados
        statusLabels: {
          paid: "Pagado",
          pending: "Pendiente",
          failed: "Fallido",
          cancelled: "Cancelado"
        }
      },
      
      // Cancelación
      cancel: {
        title: "Cancelación",
        description: "Cancelar plan",
        note: "Tu suscripción se cancelará al final del período de facturación actual",
        button: "Cancelar",
        confirmMessage: "¿Estás seguro de que deseas cancelar tu plan?"
      }
    },
     
     // ===============================================
    // 💎 SECCIÓN MI SUSCRIPCIÓN
    // ===============================================
    subscription: {
      title: "Mi Suscripción",
      subtitle: "Administra tu plan y límites de uso del sistema",
      
      // Plan actual
      current: {
        title: "Plan Actual",
        usage: "Uso Actual",
        queriesDaily: "Consultas hoy",
        queriesRemaining: "consultas restantes hoy"
      },
      
      // Estados
      status: {
        active: "Activo",
        expired: "Expirado", 
        trial: "Trial",
        expiring: "Expirando"
      },
      
      // Botones
      actions: {
        renew: "Renovar Suscripción",
        changePlan: "Cambiar Plan",
        upgrade: "Actualizar Plan",
        managePlan: "Gestionar Plan"
      },
      
      // Modal de planes
      plansModal: {
        title: "Elige tu plan",
        subtitle: "Actualiza tu suscripción para obtener más beneficios",
        billing: {
          monthly: "Mensual",
          annual: "Anual",
          save: "Ahorra hasta 34%"
        },
        currentPlan: "Plan Actual",
        popular: "Más Popular",
        savings: "Ahorra ${amount}/año vs mensual",
        annualOnly: "Este plan solo está disponible con facturación anual"
      },
      
      // Planes específicos
      plans: {
        standard: {
          name: "Standard",
          subtitle: "Ideal para técnicos con consultas básicas sobre motores Caterpillar",
          button: "Obtener plan Standard"
        },
        pro: {
          name: "Pro", 
          subtitle: "Investiga, programa y organiza",
          button: "Obtener plan Pro anual"
        },
        max: {
          name: "Max",
          subtitle: "Límites más altos, acceso prioritario", 
          button: "Obtener plan Max"
        }
      },
      
      // Características
      features: {
        dailyQueries: "consultas diarias",
        unlimitedQueries: "Consultas ilimitadas",
        whatsappSupport: "Soporte WhatsApp especializado",
        specializedDocs: "Documentación especializada", 
        prioritySupport: "Soporte prioritario",
        advancedProjects: "Proyectos técnicos avanzados",
        everythingInPro: "Todo de Pro, más:",
        higherLimits: "Límites de generación más altos",
        earlyAccess: "Acceso anticipado a funciones avanzadas",
        priorityAccess: "Acceso prioritario durante períodos de alto tráfico"
      }
    },
  
   chat: {
      title: "Asistente Técnico IA",
      subtitle: "Especializado en equipos Caterpillar",
      placeholder: "Escribe tu consulta técnica aquí...",
      thinking: "Procesando...",
      error: "Lo siento, ha ocurrido un error. Por favor, intenta nuevamente.",
      noResponse: "No se recibió respuesta válida",
      hideHistory: "Ocultar historial",
      showHistory: "Mostrar historial",
      print:"Imprimir",
      download:"Descargar",
      
      welcome: {
        hello: "¡Hola {{name}}!",
        there: "amigo",
        subtitle: "¿Cómo puedo ayudarte hoy?"
      },
      
      suggestions: {
        expert: {
          title: "Diagnóstico de fallas en equipos",
          description: "Identificar problemas técnicos y soluciones"
        },
        sales: {
          title: "Análisis de rendimiento operativo",
          description: "Optimización de máquinas Caterpillar"
        },
        organized: {
          title: "Plan de mantenimiento preventivo",
          description: "Programación de servicios técnicos"
        },
        code: {
          title: "Consulta de manuales y especificaciones",
          description: "Información técnica detallada"
        }
      },
      
      history: {
        title: "Historial de Consultas",
        search: "Buscar conversación",
        empty: "No hay conversaciones previas",
        newChat: "Nueva consulta"
      }
    },

    
    configuration: {
     btnresult:"Cambios guardados exitosamente",
      save:"Guardando...",
      saver:"Guardar cambios",
      loader:" Cargando configuración...",
       menu:{
        perfil:"Perfil",
        subscription:"Suscripción",
        account:"Cuenta",
        privacy:"Privacidad",
        notifications:"Notificaciones",
        system:"Sistema",
        configuration:"Configuración",
        configurationsubtitle:"Personaliza tu experiencia y configuración del sistema",
        },
        
       suscripcion:{
        loader:"Cargando información de suscripción...",
        title:"Mi Suscripción",
        subtitle:"Administra tu plan y límites de uso del sistema",
        current:" Plan Actual",
        days:"días restantes",
        expired:"Expirado",
        active:"Activo",
        plan:"Plan de suscripción",
        consultasdia:"consultas diarias",
        supportwtsp:"Soporte WhatsApp especializado",
        documentation:"Documentación especializada",
        soporteprio:"Soporte prioritario",
        consultasres:"consultas restantes hoy",
        consultasili:"Consultas Ilimitadas",
        expires:" expira el",
        update:"Actualizar Plan",
        renew:"Renovar Suscripción",
        manage:"Administrar Plan",
        },
      perfil: {
        title:"Perfil Personal",
        subtitle:"Administra tu información personal y cómo apareces en el sistema",
        name:"Nombre completo",
        nameplaceholder:"Ingresa tu nombre completo",
        nickname:"¿Cómo quieres que el sistema te llame?",
        nicknameplaceholder:"Nombre que aparecerá en el chat",
        email:"Correo electrónico",
        emailplaceholder:"usuario@empresa.com",
        emailinfo:"El email no se puede cambiar. Contacta al administrador si necesitas modificarlo.",
        job:"¿Qué describe mejor su trabajo?",
        select1:"Seleccione su función laboral",
        select2:"Administrador del Sistema",
        select3:"Mecánico",
        select4:"Supervisor técnico",
        select5:"Ingeniero",
        select6:"Gerente de mantenimiento",
        select7:"Operador de maquinaria",
        select8:"Estudiante",
        select9:"Otro",
        company:"Empresa",
        companyplaceholder:"Nombre de tu empresa",
        phone:"Teléfono",
        phoneplaceholder:"+5612345678",
        preferences:"¿Qué preferencias personales debe considerar el sistema en sus respuestas?",
        preferencessubtitle:"Sus preferencias se aplicarán a todas las conversaciones, dentro de las pautas del sistema.",
        preferencesplaceholder:"p. ej. hacer preguntas aclaratorias antes de dar respuestas detalladas, enfocarse en soluciones prácticas para motores Caterpillar, usar terminología técnica específica...",
        },
      },
    
    welcome: {
      greeting: "¡Hola {{name}}! 👋",
      greetingGeneric: "¡Hola! 👋",
      description: "Soy tu asistente técnico especializado en motores Caterpillar. ¿En qué puedo ayudarte hoy?",
      buenosdias: "Buenos días",
      buenastardes: "Buenas tardes",
      buenasnoches: "Buenas noches",
      bienvenido:"¡Bienvenido a KIKAI asistente técnico inteligente!",
      textobienvenido:"Estoy aquí para ayudarte con consultas especializadas sobre equipos Caterpillar. Puedo asistirte con diagnósticos, especificaciones técnicas, procedimientos de mantenimiento y más.",
      examples: {
        title: "💡 Puedes preguntar sobre:",
        motorProblem: "Problema con motor C175",
        oilChange: "Procedimiento cambio de aceite",
        errorCode: "Código de error 190-8",
        specifications: "Especificaciones técnicas motor AJ8"
      },
      icons:{
        title1:"Diagnósticos Precisos",
        title2:"Respuestas Rápidas",
        title3:"IA Avanzada",
        subtitle1:"Análisis técnico especializado",
        subtitle2:"Información al instante",
        subtitle3:"Tecnología de última generación",
      
      }
    },
    
    nav: {
      chat: "Chat Técnico",
      search: "Búsqueda",
      settings: "Configuraciones",
      support: "Soporte",
      administration: "Administración",
      help: "Ayuda"
    },
    
    history:{
      title:"Historial de Chats",
      search:"Buscar en Chat",
      newchat:"Nuevo Chat",
      today:"Hoy",
      messages:"mensajes",
      anlast:" Hace",
      yesterday:"Ayer",
      sure:"¿Estás seguro de que quieres eliminar esta conversación?",
      info:"Esta acción no se puede deshacer.",
      deletechat:"Eliminar",
      onemonent:"Hace un momento",
      expand:"Expandir historial",
      loading:"Cargando chats...",
      noresult:"No se encontraron resultados",
      nochats:"No hay chats guardados",
      initial:"Inicia una conversación para comenzar",
      
      
    },
    // ===============================================
    // 🆕 NUEVAS TRADUCCIONES PARA FAQ
    // ===============================================
    faq: {
      title: "Preguntas Frecuentes",
      description: "Encuentra respuestas rápidas a las consultas más comunes sobre motores Caterpillar",
      filters: "Filtros",
      searchPlaceholder: "Buscar en preguntas, respuestas, tags, motor, componente...",
      exploreByCategory: "Explorar por categoría",
      loading: "Cargando preguntas frecuentes...",
      error: "Error",
      showingResults: "Mostrando {{showing}} de {{total}} preguntas frecuentes",
      totalViews: "Total visualizaciones: {{count}}",
      totalHelpfulVotes: "Total votos útiles: {{count}}",
      wasHelpful: "¿Te resultó útil esta respuesta?",
      helpful: "Sí",
      notHelpful: "No",
      noResults: "No se encontraron preguntas frecuentes",
      tryAdjustingFilters: "Intenta ajustar los filtros o la búsqueda para encontrar más resultados.",
      
      // Filtros
      category: "Categoría",
      allCategories: "Todas las categorías",
      difficulty: "Dificultad",
      allDifficulties: "Todas las dificultades",
      motor: "Motor",
      allMotors: "Todos los motores",
      component: "Componente",
      allComponents: "Todos los componentes",
      sortBy: "Ordenar por",
      
      // Categorías
      categories: {
        diagnostic: "Diagnóstico",
        diagnosticDesc: "Identificación de problemas",
        maintenance: "Mantenimiento",
        maintenanceDesc: "Cuidado preventivo",
        repair: "Reparación",
        repairDesc: "Solución de problemas",
        parts: "Piezas",
        partsDesc: "Componentes y repuestos",
        installation: "Instalación",
        installationDesc: "Procedimientos de montaje",
        general: "General",
        generalDesc: "Información general"
      },
      
      // Dificultades
      difficulties: {
        beginner: "Principiante",
        intermediate: "Intermedio",
        advanced: "Avanzado"
      },
      
      // Ordenamiento
      sort: {
        relevance: "Relevancia",
        views: "Más vistas",
        helpful: "Más útiles",
        recent: "Más recientes"
      }
    },
    // ===============================================
    // 🆕 NUEVAS TRADUCCIONES PARA DOCUMENTACIÓN
    // ===============================================
    docs: {
      title: "Documentación Técnica",
      description: "Manuales, diagramas y documentos técnicos para motores Caterpillar",
      filters: "Filtros",
      searchPlaceholder: "Buscar documentos por título, descripción, motor, componente...",
      loading: "Cargando documentos...",
      error: "Error",
      showingResults: "Mostrando {{showing}} de {{total}} documentos",
      totalDownloads: "Total descargas: {{count}}",
      totalViews: "Total visualizaciones: {{count}}",
      noResults: "No se encontraron documentos",
      tryAdjustingFilters: "Intenta ajustar los filtros o la búsqueda para encontrar más resultados.",
      
      // Filtros
      category: "Categoría",
      allCategories: "Todas las categorías",
      type: "Tipo",
      allTypes: "Todos los tipos",
      motor: "Motor",
      allMotors: "Todos los motores",
      language: "Idioma",
      allLanguages: "Todos los idiomas",
      
      // Categorías
      categories: {
        operation: "Operación",
        maintenance: "Mantenimiento",
        repair: "Reparación",
        parts: "Piezas",
        safety: "Seguridad",
        installation: "Instalación"
      },
      
      // Tipos
      types: {
        manual: "Manual",
        diagram: "Diagrama",
        video: "Video",
        guide: "Guía",
        specification: "Especificación",
        troubleshooting: "Solución de problemas"
      }
    },
  
   // ✅ ADMINISTRACIÓN COMPLETA
    admin: {
      title: "Panel de Administración",
      subtitle: "Monitoreo y configuración del sistema Kikai",
      
      // TABS
      tabs: {
        overview: "Resumen",
        equipment: "Equipos",
        searches: "Búsquedas",
        analytics: "Analytics",
        users: "Usuarios",
        plans: "Planes",
        payments: "Pagos",
        documents: "Documentos",
        faq: "FAQ",
        config: "Configuración"
      },

      // ACCIONES GENERALES
      actions: {
        refresh: "Actualizar",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        create: "Crear",
        upload: "Subir",
        download: "Descargar",
        export: "Exportar",
        import: "Importar",
        search: "Buscar",
        filter: "Filtrar",
        reset: "Resetear",
        apply: "Aplicar",
        close: "Cerrar",
        confirm: "Confirmar",
        view: "Ver",
        details: "Detalles"
      },

      // ESTADÍSTICAS
      stats: {
        uptime: "Tiempo de Servidor",
        equipmentCount: "Equipos en BD",
        searchesToday: "Búsquedas Hoy",
        cacheHit: "Cache Hit Rate",
        totalUsers: "Total Usuarios",
        activeUsers: "Usuarios Activos",
        premiumUsers: "Usuarios Premium",
        revenue: "Ingresos del Mes"
      },

      // SERVIDOR
      server: {
        info: "Información del Servidor",
        memoryUsed: "Memoria Usada",
        memoryTotal: "Memoria Total",
        version: "Versión"
      },

      // SERVICIOS
      services: {
        status: "Estado de Servicios",
        database: "Base de Datos",
        ai: "Servicio de IA",
        healthy: "saludable",
        error: "error"
      },

      // EQUIPOS
      equipment: {
        title: "Equipos Cargados",
        count: "Total",
        serial: "Serie",
        model: "Modelo",
        type: "Tipo",
        status: "Estado",
        lastScraped: "Última Actualización",
        noData: "No hay equipos cargados"
      },

      // BÚSQUEDAS
      searches: {
        stats: "Estadísticas de Búsqueda",
        registered: "Búsquedas registradas",
        popular: "Consultas Más Buscadas",
        times: "veces",
        avgResults: "resultados promedio",
        noQueries: "No hay consultas registradas",
        trending: "Tendencias",
        performance: "Rendimiento",
        topQueries: "Top Consultas",
        searchVolume: "Volumen de Búsqueda",
        successRate: "Tasa de Éxito",
        avgResponseTime: "Tiempo Promedio de Respuesta"
      },

      // ANALYTICS
      analytics: {
        queries: "Consultas populares",
        dashboard: "Panel de Analytics",
        reports: "Reportes",
        metrics: "Métricas",
        insights: "Insights",
        trends: "Tendencias",
        conversion: "Conversión",
        retention: "Retención"
      },

      // USUARIOS
      users: {
        title: "Gestión de Usuarios",
        add: "Agregar Usuario",
        edit: "Editar Usuario",
        total: "Total de Usuarios",
        active: "Usuarios Activos",
        
        table: {
          user: "Usuario",
          email: "Email",
          subscription: "Suscripción",
          queries: "Consultas",
          lastLogin: "Último Login",
          actions: "Acciones",
          status: "Estado",
          role: "Rol",
          registered: "Registrado"
        },
        
        filters: {
          all: "Todos",
          premium: "Premium",
          trial: "Prueba",
          expired: "Expirados",
          active: "Activos",
          inactive: "Inactivos"
        },

        form: {
          name: "Nombre completo",
          email: "Correo electrónico",
          password: "Contraseña",
          role: "Rol de usuario",
          subscription: "Tipo de suscripción",
          queriesLimit: "Límite de consultas",
          status: "Estado de cuenta",
          phone: "Teléfono",
          company: "Empresa",
          notes: "Notas"
        },

        roles: {
          admin: "Administrador",
          user: "Usuario",
          premium: "Usuario Premium",
          moderator: "Moderador"
        },

        status: {
          active: "Activo",
          inactive: "Inactivo",
          suspended: "Suspendido",
          pending: "Pendiente"
        },

        actions: {
          viewDetails: "Ver detalles",
          editUser: "Editar usuario",
          deleteUser: "Eliminar usuario",
          suspendUser: "Suspender usuario",
          activateUser: "Activar usuario",
          resetPassword: "Resetear contraseña",
          sendEmail: "Enviar email"
        },

        confirmations: {
          delete: "¿Estás seguro de que deseas eliminar este usuario?",
          suspend: "¿Deseas suspender este usuario?",
          activate: "¿Deseas activar este usuario?",
          resetPassword: "¿Enviar nueva contraseña al usuario?",
          bulkDelete: "¿Eliminar {{count}} usuarios seleccionados?"
        }
      },
   
      // PLANS
      plans: {
        title: "Gestión de planes",
        add: "Crear plan",
        edit:  "Editar plan",
        monthly: "Mes",
        yearly: "Año",
        queriesLimit: "Límite de consultas",
        active: "Activo",
        inactive: "Inactivo",
        
        form: {
          name: "Nombre del plan",
          description: "Descripción",
          price: "Precio",
          currency: "Moneda",
          interval: "Intervalo de facturación",
          queriesLimit: "Límite de consultas",
          features: "Funciones incluidas",
          isActive: "Plan activo",
          priority: "Prioridad de soporte",
          storageLimit: "Límite de almacenamiento"
        },

        features: {
          unlimitedQueries: "Consultas ilimitadas",
          prioritySupport: "Soporte prioritario",
          advancedAnalytics: "Análisis avanzado",
          customIntegration: "Integración personalizada",
          dedicatedManager: "Gestor dedicado",
          apiAccess: "Acceso a la API",
          whatsappSupport: "Soporte de WhatsApp",
          phoneSupport: "Soporte telefónico"
        }
      },

      // PAYMENTS
      payments: {
        title: "Historial de pagos",
        total: "Total de pagos",
        thisMonth: "Este mes",
        
        table: {
          user: "Usuario",
          plan: "Plan",
          amount: "Monto",
          status: "Estado",
          method: "Método",
          date: "Fecha",
          actions: "Acciones",
          invoice: "Factura",
          transaction: "Transacción"
        },
        
        filters: {
          all: "Todos",
          completed: "Completado",
          pending: "Pendiente",
          failed: "Fallido",
          refunded: "Reembolsado"
        },

        status: {
          completed: "Completado",
          pending: "Pendiente",
          failed: "Fallido",
          refunded: "Reembolsado",
          cancelled: "Cancelado"
        },

        methods: {
          card: "Tarjeta",
          paypal: "PayPal",
          transfer: "Transferencia",
          crypto: "Criptomoneda"
        },

        actions: {
          viewInvoice: "Ver factura",
          downloadInvoice: "Descargar factura",
          refund: "Reembolso",
          resend: "Reenviar"
        }
      },

      // DOCUMENTS
      // DOCUMENTOS
      documents: {
        title: "Gestión de Documentos",
        upload: "Subir Documento",
        uploading: "Subiendo...",
        total: "Total de Documentos",
        
        table: {
          title: "Título",
          category: "Categoría",
          size: "Tamaño",
          type: "Tipo",
          uploaded: "Subido",
          downloads: "Descargas",
          actions: "Acciones"
        },
        
        filters: {
          all: "Todos",
          public: "Públicos",
          private: "Privados",
          manuals: "Manuales",
          guides: "Guías",
          specifications: "Especificaciones"
        },

        categories: {
          manual: "Manual",
          guide: "Guía",
          specification: "Especificación",
          procedure: "Procedimiento",
          diagram: "Diagrama",
          troubleshooting: "Resolución de problemas",
          maintenance: "Mantenimiento",
          parts: "Piezas"
        },

        form: {
          title: "Título del documento",
          description: "Descripción",
          category: "Categoría",
          visibility: "Visibilidad",
          tags: "Etiquetas",
          version: "Versión"
        },

        visibility: {
          public: "Público",
          private: "Privado",
          restricted: "Restringido"
        },

        actions: {
          preview: "Vista previa",
          download: "Descargar",
          edit: "Editar info",
          delete: "Eliminar",
          share: "Compartir"
        },

        confirmDelete: "¿Eliminar documento?",
        downloads: "Descargas",
        uploadedBy: "Subido por"
      },

      // FAQ
      faq: {
        title: "Gestión de FAQ",
        add: "Agregar FAQ",
        edit: "Editar FAQ",
        category: "Categoría",
        order: "Orden",
        active: "Activo",
        inactive: "Inactivo",
        
        form: {
          question: "Pregunta",
          answer: "Respuesta",
          category: "Categoría",
          order: "Orden de aparición",
          isActive: "FAQ activo",
          tags: "Etiquetas",
          helpfulness: "Utilidad"
        },

        categories: {
          general: "General",
          technical: "Técnico",
          billing: "Facturación",
          account: "Cuenta",
          troubleshooting: "Resolución de problemas",
          features: "Características"
        },

        placeholder: {
          question: "Escribe tu pregunta aquí...",
          answer: "Proporciona una respuesta detallada..."
        }
      },

      // EXPORTACIÓN
      export: {
        title: "Exportar Datos",
        users: "Exportar Usuarios",
        payments: "Exportar Pagos",
        analytics: "Exportar Analytics",
        format: "Formato",
        dateRange: "Rango de Fechas",
        filters: "Filtros",
        generating: "Generando reporte...",
        ready: "Reporte listo para descargar",
        csv: "CSV",
        excel: "Excel",
        pdf: "PDF"
      },

      // PAGINACIÓN
      pagination: {
        showing: "Mostrando {{start}} a {{end}} de {{total}} resultados",
        previous: "Anterior",
        next: "Siguiente",
        page: "Página",
        of: "de",
        rowsPerPage: "Filas por página",
        goToPage: "Ir a la página"
      },

      // NOTIFICACIONES
      notifications: {
        userCreated: "Usuario creado exitosamente",
        userUpdated: "Usuario actualizado exitosamente",
        userDeleted: "Usuario eliminado exitosamente",
        planCreated: "Plan creado exitosamente",
        planUpdated: "Plan actualizado exitosamente",
        planDeleted: "Plan eliminado exitosamente",
        documentUploaded: "Documento subido exitosamente",
        documentDeleted: "Documento eliminado exitosamente",
        faqCreated: "FAQ creada exitosamente",
        faqUpdated: "FAQ actualizada exitosamente",
        faqDeleted: "FAQ eliminada exitosamente",
        dataExported: "Datos exportados exitosamente",
        error: "Ha ocurrido un error",
        saved: "Cambios guardados",
        loading: "Cargando..."
      }
    },
    
     tickets: {
      title: 'Tickets',
      hello: 'Hola',
      subtitle: 'Aquí están las cosas que suceden en tu soporte',
      newTicket: 'Nuevo Ticket',
      locale: 'es',
      stats: {
        open: 'Tickets abiertos',
        waiting: 'Esperando respuesta',
        active: 'Tickets activos',
        resolved: 'Tickets resueltos'
      },
      
      filters: {
        search: 'Buscar tickets...',
        allStatus: 'Todos los Estados',
        allPriority: 'Todas las Prioridades',
        allAssignees: 'Todos los Asignados',
        resetFilters: 'Resetear Filtros'
      },
      
      table: {
        title: 'Título',
        status: 'Estado',
        priority: 'Prioridad',
        assignee: 'Asignado',
        updated: 'Actualizado',
        created: 'Creado el',
        unassigned: 'Sin asignar'
      },
      
      status: {
        new: 'Nuevo',
        waiting: 'Esperando',
        assigned: 'Asignado',
        inProgress: 'En Progreso',
        waitingCustomer: 'Esperando Cliente',
        resolved: 'Resuelto',
        closed: 'Cerrado'
      },
      
      priority: {
        low: 'Baja',
        medium: 'Media',
        high: 'Alta',
        critical: 'Crítica'
      },
      
   wizard: {
      title: 'Crear Nuevo Ticket',
      steps: {
        basic: 'Información Básica',
        details: 'Detalles',
        technical: 'Información Técnica',
        review: 'Revisar'
      },
      fields: {
        title: 'Título del Ticket',
        titlePlaceholder: 'Describe brevemente tu problema',
        category: 'Categoría',
        selectCategory: 'Selecciona una categoría',
        priority: 'Prioridad',
        selectPriority: 'Selecciona prioridad',
        description: 'Descripción Detallada',
        descriptionPlaceholder: 'Describe tu problema en detalle...',
        motor: 'Motor',
        motorPlaceholder: 'Ej: C27, L46, etc.',
        configuration: 'Configuración',
        configurationPlaceholder: 'Ej: L4G, C27, etc.',
        component: 'Componente',
        componentPlaceholder: 'Ej: Válvulas, Sistema eléctrico',
        partNumber: 'Número de Parte',
        partNumberPlaceholder: 'Ej: 12345-ABC-678'
      },
      categories: {
        diagnostic: 'Diagnóstico',
        maintenance: 'Mantenimiento',
        repair: 'Reparación',
        consultation: 'Consulta',
        other: 'Otro'
      },
      actions: {
        next: 'Siguiente',
        previous: 'Anterior',
        submit: 'Crear Ticket',
        cancel: 'Cancelar',
        submitting: 'Creando...'
      },
      validation: {
        titleRequired: 'El título es requerido',
        titleMin: 'El título debe tener al menos 10 caracteres',
        categoryRequired: 'Selecciona una categoría',
        priorityRequired: 'Selecciona una prioridad',
        descriptionRequired: 'La descripción es requerida',
        descriptionMin: 'La descripción debe tener al menos 20 caracteres'
      },
      preview: {
        title: 'Revisa tu Ticket',
        subtitle: 'Verifica que toda la información sea correcta antes de crear el ticket',
        basicInfo: 'Información Básica',
        technicalInfo: 'Información Técnica',
        optional: 'Opcional'
      },
      success: {
        created: 'Ticket creado exitosamente',
        redirecting: 'Redirigiendo...'
      }
    }, 
      
      detail: {
        backToTickets: 'Volver a tickets',
        label: 'Etiqueta',
        assignedTo: 'Asignado a',
        dueDate: 'Fecha límite',
        description: 'Descripción',
        comments: 'Comentarios',
        attachments: 'Adjuntos',
        activity: 'Actividad',
        writeComment: 'Escribir comentario',
        send: 'Enviar',
        noAttachments: 'No hay adjuntos aún',
        hasChange: 'ha cambiado',
        statusTo: 'estado a',
        commentOnYour: 'comentó en tu',
        addedTags: 'agregó etiquetas',
        addedDocument: 'agregó documento',
        assignedTicket: 'asignó ticket',
        technicalInfo: 'Información Técnica',
        configuration: 'Configuración',
        component: 'Componente',
        partNumber: 'Número de Parte',
        noComments: 'No hay comentarios aún',
        ticketCreated: 'Ticket creado',
        lastUpdate: 'Última actualización',
        by: 'por'
      },
        time: {
          justNow: 'Justo ahora', // ES
          ago: 'hace' // ES
        },
        pagination: {
          showing: 'Mostrando',
          of: 'de'
        },
      empty: {
        title: 'No se encontraron tickets',
        description: 'Intenta ajustar tu búsqueda o filtros'
      },
       actions: { 
          edit: 'Editar',
          save: 'Guardar',
          saving: 'Guardando...',
          cancel: 'Cancelar',
          delete: 'Eliminar'
        },
        errors: {
          loadFailed: 'Error al cargar ticket',
          updateFailed: 'Error al actualizar ticket',
          deleteFailed: 'Error al eliminar ticket'
        },
        success: {
          updated: 'Ticket actualizado exitosamente',
          deleted: 'Ticket eliminado exitosamente'
        },
        confirm: {
          delete: '¿Estás seguro de eliminar este ticket?'
        },
    }

 },  
  en: {
    
    wtsp: {
      title:"Attention WhatsApp Premium",
      subtitle:"Connect directly with our Caterpillar engine technicians. Personalized support 24/7.",
      diagnostic:"Technical Diagnosis",
      diagnosticsub:"Immediate diagnosis of problems in Caterpillar engines",
      online:"online now",
      available:"12 technicians available • Response time: < 2 minutes",
      repair: 'Repair Guide',
      repairsub:'Step-by-step repair assistance',
      consultation:'Specialized Consulting',
      consultationsub:'Consulting session with a senior technician',
      emergency:'Emergency Support',
      emergencysub:'Immediate attention for critical problems',
      techs:'Available Technicians',
      timeprom:'Average Time',
      satisfaction:'Satisfaction',
      availability:'Availability',
    }, 
    
    system: {
      online: "System Online",
      offline: "System Offline",
      connecting: "System Connecting...",
      lastCheck: "Last check:",
      never: "Never"
    },
    
    user: {
      greeting: "Hello, {{name}}"
    },
    
    theme: {
      switchToLight: "Switch to light theme",
      switchToDark: "Switch to dark theme"
    },
    
    footer: {
      copyright: "Kikai System © 2025 - Intelligent Technical Assistant"
    },
    
      // ✅ AGREGAR ESTA SECCIÓN COMPLETA:
    billing: {
      title: "Billing",
      subtitle: "Manage your payment method, current plan and billing history",
      
      // Current plan
      plan: {
        name: "Pro Plan",
        type: "Monthly",
        renewal: "Your subscription will automatically renew on Oct 5, 2025.",
        adjustPlan: "Adjust plan"
      },
      
      // Payment method
      payment: {
        title: "Payment",
        update: "Update",
        noMethod: "No payment method configured",
        addMethod: "Add payment method"
      },
      
      // Payment modal
      modal: {
        title: "Payment method",
        selectedPlan: "Selected Plan"
      },
      
      // Form
      form: {
        fullName: "Full name",
        fullNamePlaceholder: "John Doe",
        country: "Country or region",
        address: "Address line 1",
        addressPlaceholder: "123 Main Street",
        cardNumber: "Card number",
        expiryDate: "Expiry date",
        securityCode: "Security code",
        taxId: "Tax identification number (Optional)",
        taxIdHint: "When using a tax identification number, the \"full name\" above should be your company name.",
        cancel: "Cancel",
        update: "Update",
        
        // Errors
        errors: {
          fullNameRequired: "Full name is required",
          addressRequired: "Address is required",
          invalidCardNumber: "Invalid card number",
          invalidExpiryDate: "Invalid expiry date",
          invalidCVC: "Invalid security code",
          cardValidationError: "Error validating card"
        }
      },
      
      // Invoices
      invoices: {
        title: "Invoices",
        date: "Date",
        total: "Total",
        status: "Status",
        actions: "Actions",
        view: "View",
        
        // Status labels
        statusLabels: {
          paid: "Paid",
          pending: "Pending",
          failed: "Failed",
          cancelled: "Cancelled"
        }
      },
      
      // Cancellation
      cancel: {
        title: "Cancellation",
        description: "Cancel plan",
        note: "Your subscription will be cancelled at the end of the current billing period",
        button: "Cancel",
        confirmMessage: "Are you sure you want to cancel your plan?"
      }
    },
    
     subscription: {
      title: "My Subscription",
      subtitle: "Manage your plan and system usage limits",
      
      // Current plan
      current: {
        title: "Current Plan",
        usage: "Current Usage",
        queriesDaily: "Queries today",
        queriesRemaining: "queries remaining today"
      },
      
      // Status
      status: {
        active: "Active",
        expired: "Expired",
        trial: "Trial", 
        expiring: "Expiring"
      },
      
      // Actions
      actions: {
        renew: "Renew Subscription",
        changePlan: "Change Plan",
        upgrade: "Upgrade Plan",
        managePlan: "Manage Plan"
      },
      
      // Plans modal
      plansModal: {
        title: "Choose your plan",
        subtitle: "Update your subscription to get more benefits",
        billing: {
          monthly: "Monthly",
          annual: "Annual",
          save: "Save up to 34%"
        },
        currentPlan: "Current Plan",
        popular: "Most Popular",
        savings: "Save ${amount}/year vs monthly",
        annualOnly: "This plan is only available with annual billing"
      },
      
      // Specific plans
      plans: {
        standard: {
          name: "Standard",
          subtitle: "Ideal for technicians with basic Caterpillar motor queries",
          button: "Get Standard plan"
        },
        pro: {
          name: "Pro",
          subtitle: "Research, program and organize", 
          button: "Get Pro annual plan"
        },
        max: {
          name: "Max",
          subtitle: "Higher limits, priority access",
          button: "Get Max plan"
        }
      },
      
      // Features
      features: {
        dailyQueries: "daily queries",
        unlimitedQueries: "Unlimited queries",
        whatsappSupport: "Specialized WhatsApp support",
        specializedDocs: "Specialized documentation",
        prioritySupport: "Priority support", 
        advancedProjects: "Advanced technical projects",
        everythingInPro: "Everything in Pro, plus:",
        higherLimits: "Higher generation limits",
        earlyAccess: "Early access to advanced features",
        priorityAccess: "Priority access during high traffic periods"
      }
    },
      
    chat: {
      title: "Technical AI Assistant",
      subtitle: "Specialized in Caterpillar equipment",
      placeholder: "Enter your technical query here...",
      thinking: "Processing...",
      error: "Sorry, an error occurred. Please try again.",
      noResponse: "No valid response received",
      hideHistory: "Hide history",
      showHistory: "Show history",
      print:"Print",
      download:"Download",
      welcome: {
        hello: "Hello {{name}}!",
        there: "there",
        subtitle: "How can I help you today?"
      },
      
      suggestions: {
        expert: {
          title: "Equipment failure diagnosis",
          description: "Identify technical problems and solutions"
        },
        sales: {
          title: "Operational performance analysis",
          description: "Caterpillar machine optimization"
        },
        organized: {
          title: "Preventive maintenance plan",
          description: "Technical service scheduling"
        },
        code: {
          title: "Manuals and specifications consultation",
          description: "Detailed technical information"
        }
      },
      
      history: {
        title: "Query History",
        search: "Search conversation",
        empty: "No previous conversations",
        newChat: "New query"
      }
    },
    configuration: {
      btnresult:"Changes saved successfully",
      save:"Saving...",
      saver:"Save changes",
      loader:"Loading configuration...",
      menu:{
        perfil:"Profile",
        subscription:"Subscription",
        account:"Account",
        privacy:"Privacy",
        notifications:"Notifications",
        system:"System",
        configuration:"Settings",
        configurationsubtitle:"Customize your experience and system settings",
        },
      suscripcion:{
        loader:"Loading subscription information...",
        title:"My Subscription",
        subtitle:"Manage your plan and system usage limits",
        current:"Current Plan",
        days:"days remaining",
        expired:"Expired",
        active:"Active",
        plan:"Subscription Plan",
        consultesdia:"Daily consulters",
        supportwtsp:"Dedicated WhatsApp Support",
        documentation:"Dedicated Documentation",
        supportprio:"Priority Support",
        consultesres:"Consultations remaining today",
        consultesili:"Unlimited Consultations",
        expires:"Expires on",
        update:"Update Plan",
        renew:"Renew Subscription",
        manage:"Manage Plan",
        },  
      perfil: {
        title:"Personal Profile",
        subtitle:"Manage your personal information and how you appear in the system",
        name:"Full name",
        nameplaceholder:"Enter your full name",
        nickname:"What do you want the system to call you?",
        nicknameplaceholder:"Name that will appear in the chat",
        email:"Email",
        emailplaceholder:"user@company.com",
        emailinfo:"The email cannot be changed. Contact the administrator if you need to change it.",
        job:"What best describes your job?",
        select1:"Select your job function",
        select2:"System Administrator",
        select3:"Mechanic",
        select4:"Technical Supervisor",
        select5:"Engineer",
        select6:"Maintenance Manager",
        select7:"Machine Operator",
        select8:"Student",
        select9:"Other",
        company:"Company",
        companyplaceholder:"Your company name",
        phone:"Phone",
        phoneplaceholder:"+5612345678",
        preferences:"What personal preferences should the system consider in its responses?",
        preferencessubtitle:"Your preferences will apply to all conversations, within the system's guidelines.",
        preferencesplaceholder:"e.g., asking clarifying questions before giving detailed answers, focusing on practical solutions for Caterpillar engines, using specific technical terminology...",
        },
      },
    
    welcome: {
      greeting: "Hello {{name}}! 👋",
      greetingGeneric: "Hello! 👋",
      description: "I'm your technical assistant specialized in Caterpillar engines. How can I help you today?",
      buenosdias: "Good morning",
      buenastardes: "Good afternoon",
      buenasnoches: "Good night",
      bienvenido: "Welcome to KIKAI Smart Tech Assistant!",
      textobienvenido:"I'm here to help you with specialized questions about Caterpillar equipment. I can assist you with diagnostics, technical specifications, maintenance procedures, and more.",
      
      examples: {
        title: "💡 You can ask about:",
        motorProblem: "Problem with C175 engine",
        oilChange: "Oil change procedure",
        errorCode: "Error code 190-8",
        specifications: "AJ8 engine technical specifications"
      },
      icons:{
        title1:"Accurate Diagnostics",
        title2:"Rapid Responses",
        title3:"Advanced AI",
        subtitle1:"Specialized Technical Analysis",
        subtitle2:"Instant Information",
        subtitle3:"State-of-the-art Technology",
        
        }
    },
    
    nav: {
      chat: "Technical Chat",
      search: "Search",
      settings: "Settings",
      support: "Support",
      administration: "Administration",
      help: "Help"
    },
    
    // ===============================================
    // 🆕 NEW TRANSLATIONS FOR FAQ
    // ===============================================
    faq: {
      title: "Frequently Asked Questions",
      description: "Find quick answers to the most common questions about Caterpillar engines",
      filters: "Filters",
      searchPlaceholder: "Search in questions, answers, tags, engine, component...",
      exploreByCategory: "Explore by category",
      loading: "Loading frequently asked questions...",
      error: "Error",
      showingResults: "Showing {{showing}} of {{total}} frequently asked questions",
      totalViews: "Total views: {{count}}",
      totalHelpfulVotes: "Total helpful votes: {{count}}",
      wasHelpful: "Was this answer helpful?",
      helpful: "Yes",
      notHelpful: "No",
      noResults: "No frequently asked questions found",
      tryAdjustingFilters: "Try adjusting the filters or search to find more results.",
      
      // Filters
      category: "Category",
      allCategories: "All categories",
      difficulty: "Difficulty",
      allDifficulties: "All difficulties",
      motor: "Engine",
      allMotors: "All engines",
      component: "Component",
      allComponents: "All components",
      sortBy: "Sort by",
      
      // Categories
      categories: {
        diagnostic: "Diagnostic",
        diagnosticDesc: "Problem identification",
        maintenance: "Maintenance",
        maintenanceDesc: "Preventive care",
        repair: "Repair",
        repairDesc: "Problem solving",
        parts: "Parts",
        partsDesc: "Components and spare parts",
        installation: "Installation",
        installationDesc: "Assembly procedures",
        general: "General",
        generalDesc: "General information"
      },
      
      // Difficulties
      difficulties: {
        beginner: "Beginner",
        intermediate: "Intermediate",
        advanced: "Advanced"
      },
      
      // Sorting
      sort: {
        relevance: "Relevance",
        views: "Most viewed",
        helpful: "Most helpful",
        recent: "Most recent"
      }
    },

    // ===============================================
    // 🆕 NEW TRANSLATIONS FOR DOCUMENTATION
    // ===============================================
    docs: {
      title: "Technical Documentation",
      description: "Manuals, diagrams and technical documents for Caterpillar engines",
      filters: "Filters",
      searchPlaceholder: "Search documents by title, description, engine, component...",
      loading: "Loading documents...",
      error: "Error",
      showingResults: "Showing {{showing}} of {{total}} documents",
      totalDownloads: "Total downloads: {{count}}",
      totalViews: "Total views: {{count}}",
      noResults: "No documents found",
      tryAdjustingFilters: "Try adjusting the filters or search to find more results.",
      
      // Filters
      category: "Category",
      allCategories: "All categories",
      type: "Type",
      allTypes: "All types",
      motor: "Engine",
      allMotors: "All engines",
      language: "Language",
      allLanguages: "All languages",
      
      // Categories
      categories: {
        operation: "Operation",
        maintenance: "Maintenance",
        repair: "Repair",
        parts: "Parts",
        safety: "Safety",
        installation: "Installation"
      },
      
      // Types
      types: {
        manual: "Manual",
        diagram: "Diagram",
        video: "Video",
        guide: "Guide",
        specification: "Specification",
        troubleshooting: "Troubleshooting"
      }
    },
  
    
    history:{
      title: "Chat History",
      search: "Search Chat",
      newchat: "New Chat",
      today: "Today",
      messages: "messages",
      anlast: "Ago",
      yesterday: "Yesterday",
      sure: "Are you sure you want to delete this conversation?",
      info: "This action can't be undone.",
      deletechat: "Delete",
      onemonent: "Just a moment ago",
      expand: "Expand history",
      loading: "Loading chats...",
      noresult: "No results found",
      nochats: "No saved chats",
      initial: "Start a conversation to get started",
      
      },
   
    // ✅ COMPLETE ADMINISTRATION
    admin: {
      title: "Administration Panel",
      subtitle: "Kikai system monitoring and configuration",
      
      // TABS
      tabs: {
        overview: "Overview",
        equipment: "Equipment",
        searches: "Searches",
        analytics: "Analytics",
        users: "Users",
        plans: "Plans",
        payments: "Payments",
        documents: "Documents",
        faq: "FAQ",
        config: "Configuration"
      },

      // GENERAL ACTIONS
      actions: {
        refresh: "Refresh",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        create: "Create",
        upload: "Upload",
        download: "Download",
        export: "Export",
        import: "Import",
        search: "Search",
        filter: "Filter",
        reset: "Reset",
        apply: "Apply",
        close: "Close",
        confirm: "Confirm",
        view: "View",
        details: "Details"
      },

      // STATISTICS
      stats: {
        uptime: "Server Uptime",
        equipmentCount: "Equipment in DB",
        searchesToday: "Searches Today",
        cacheHit: "Cache Hit Rate",
        totalUsers: "Total Users",
        activeUsers: "Active Users",
        premiumUsers: "Premium Users",
        revenue: "Monthly Revenue"
      },

      // SERVER
      server: {
        info: "Server Information",
        memoryUsed: "Memory Used",
        memoryTotal: "Total Memory",
        version: "Version"
      },

      // SERVICES
      services: {
        status: "Services Status",
        database: "Database",
        ai: "AI Service",
        healthy: "healthy",
        error: "error"
      },

      // EQUIPMENT
      equipment: {
        title: "Loaded Equipment",
        count: "Total",
        serial: "Serial",
        model: "Model",
        type: "Type",
        status: "Status",
        lastScraped: "Last Update",
        noData: "No equipment loaded"
      },

      // SEARCHES
      searches: {
        stats: "Search Statistics",
        registered: "Registered searches",
        popular: "Most Searched Queries",
        times: "times",
        avgResults: "average results",
        noQueries: "No registered queries",
        trending: "Trending",
        performance: "Performance",
        topQueries: "Top Queries",
        searchVolume: "Search Volume",
        successRate: "Success Rate",
        avgResponseTime: "Average Response Time"
      },

      // ANALYTICS
      analytics: {
        queries: "Popular queries",
        dashboard: "Analytics Dashboard",
        reports: "Reports",
        metrics: "Metrics",
        insights: "Insights",
        trends: "Trends",
        conversion: "Conversion",
        retention: "Retention"
      },

      // USERS - Complete translations
      users: {
        title: "User Management",
        add: "Add User",
        edit: "Edit User",
        total: "Total Users",
        active: "Active Users",
        
        table: {
          user: "User",
          email: "Email",
          subscription: "Subscription",
          queries: "Queries",
          lastLogin: "Last Login",
          actions: "Actions",
          status: "Status",
          role: "Role",
          registered: "Registered"
        },
        
        filters: {
          all: "All",
          premium: "Premium",
          trial: "Trial",
          expired: "Expired",
          active: "Active",
          inactive: "Inactive"
        },

        form: {
          name: "Full name",
          email: "Email address",
          password: "Password",
          role: "User role",
          subscription: "Subscription type",
          queriesLimit: "Queries limit",
          status: "Account status",
          phone: "Phone",
          company: "Company",
          notes: "Notes"
        },

        roles: {
          admin: "Administrator",
          user: "User",
          premium: "Premium User",
          moderator: "Moderator"
        },

        status: {
          active: "Active",
          inactive: "Inactive",
          suspended: "Suspended",
          pending: "Pending"
        },

        actions: {
          viewDetails: "View details",
          editUser: "Edit user",
          deleteUser: "Delete user",
          suspendUser: "Suspend user",
          activateUser: "Activate user",
          resetPassword: "Reset password",
          sendEmail: "Send email"
        },

        confirmations: {
          delete: "Are you sure you want to delete this user?",
          suspend: "Do you want to suspend this user?",
          activate: "Do you want to activate this user?",
          resetPassword: "Send new password to user?",
          bulkDelete: "Delete {{count}} selected users?"
        }
      },

      // PLANS
      plans: {
        title: "Plan Management",
        add: "Create Plan",
        edit: "Edit Plan",
        monthly: "month",
        yearly: "year",
        queriesLimit: "Queries limit",
        active: "Active",
        inactive: "Inactive",
        
        form: {
          name: "Plan name",
          description: "Description",
          price: "Price",
          currency: "Currency",
          interval: "Billing interval",
          queriesLimit: "Queries limit",
          features: "Included features",
          isActive: "Active plan",
          priority: "Support priority",
          storageLimit: "Storage limit"
        },

        features: {
          unlimitedQueries: "Unlimited queries",
          prioritySupport: "Priority support",
          advancedAnalytics: "Advanced analytics",
          customIntegration: "Custom integration",
          dedicatedManager: "Dedicated manager",
          apiAccess: "API access",
          whatsappSupport: "WhatsApp support",
          phoneSupport: "Phone support"
        }
      },

      // PAYMENTS
      payments: {
        title: "Payment History",
        total: "Total Payments",
        thisMonth: "This Month",
        
        table: {
          user: "User",
          plan: "Plan",
          amount: "Amount",
          status: "Status",
          method: "Method",
          date: "Date",
          actions: "Actions",
          invoice: "Invoice",
          transaction: "Transaction"
        },
        
        filters: {
          all: "All",
          completed: "Completed",
          pending: "Pending",
          failed: "Failed",
          refunded: "Refunded"
        },

        status: {
          completed: "Completed",
          pending: "Pending",
          failed: "Failed",
          refunded: "Refunded",
          cancelled: "Cancelled"
        },

        methods: {
          card: "Card",
          paypal: "PayPal",
          transfer: "Transfer",
          crypto: "Cryptocurrency"
        },

        actions: {
          viewInvoice: "View invoice",
          downloadInvoice: "Download invoice",
          refund: "Refund",
          resend: "Resend"
        }
      },

      // DOCUMENTS
      documents: {
        title: "Document Management",
        upload: "Upload Document",
        uploading: "Uploading...",
        total: "Total Documents",
        
        table: {
          title: "Title",
          category: "Category",
          size: "Size",
          type: "Type",
          uploaded: "Uploaded",
          downloads: "Downloads",
          actions: "Actions"
        },
        
        filters: {
          all: "All",
          public: "Public",
          private: "Private",
          manuals: "Manuals",
          guides: "Guides",
          specifications: "Specifications"
        },

        categories: {
          manual: "Manual",
          guide: "Guide",
          specification: "Specification",
          procedure: "Procedure",
          diagram: "Diagram",
          troubleshooting: "Troubleshooting",
          maintenance: "Maintenance",
          parts: "Parts"
        },

        form: {
          title: "Document title",
          description: "Description",
          category: "Category",
          visibility: "Visibility",
          tags: "Tags",
          version: "Version"
        },

        visibility: {
          public: "Public",
          private: "Private",
          restricted: "Restricted"
        },

        actions: {
          preview: "Preview",
          download: "Download",
          edit: "Edit info",
          delete: "Delete",
          share: "Share"
        },

        confirmDelete: "Delete document?",
        downloads: "Downloads",
        uploadedBy: "Uploaded by"
      },

      // FAQ
      faq: {
        title: "FAQ Management",
        add: "Add FAQ",
        edit: "Edit FAQ",
        category: "Category",
        order: "Order",
        active: "Active",
        inactive: "Inactive",
        
        form: {
          question: "Question",
          answer: "Answer",
          category: "Category",
          order: "Display order",
          isActive: "Active FAQ",
          tags: "Tags",
          helpfulness: "Helpfulness"
        },

        categories: {
          general: "General",
          technical: "Technical",
          billing: "Billing",
          account: "Account",
          troubleshooting: "Troubleshooting",
          features: "Features"
        },

        placeholder: {
          question: "Type your question here...",
          answer: "Provide a detailed answer..."
        }
      },

      // EXPORT
      export: {
        title: "Export Data",
        users: "Export Users",
        payments: "Export Payments",
        analytics: "Export Analytics",
        format: "Format",
        dateRange: "Date Range",
        filters: "Filters",
        generating: "Generating report...",
        ready: "Report ready for download",
        csv: "CSV",
        excel: "Excel",
        pdf: "PDF"
      },

      // PAGINATION
      pagination: {
        showing: "Showing {{start}} to {{end}} of {{total}} results",
        previous: "Previous",
        next: "Next",
        page: "Page",
        of: "of",
        rowsPerPage: "Rows per page",
        goToPage: "Go to page"
      },

      // NOTIFICATIONS
      notifications: {
        userCreated: "User created successfully",
        userUpdated: "User updated successfully",
        userDeleted: "User deleted successfully",
        planCreated: "Plan created successfully",
        planUpdated: "Plan updated successfully",
        planDeleted: "Plan deleted successfully",
        documentUploaded: "Document uploaded successfully",
        documentDeleted: "Document deleted successfully",
        faqCreated: "FAQ created successfully",
        faqUpdated: "FAQ updated successfully",
        faqDeleted: "FAQ deleted successfully",
        dataExported: "Data exported successfully",
        error: "An error occurred",
        saved: "Changes saved",
        loading: "Loading..."
      }
    },
   
   tickets: {
      title: 'Tickets',
      hello: 'Hello',
      subtitle: 'Here are the things happening in your support',
      newTicket: 'New Ticket',
      locale: 'en',
      stats: {
        open: 'Open tickets',
        waiting: 'Waiting reply',
        active: 'Active tickets',
        resolved: 'Resolved tickets'
      },
      
      filters: {
        search: 'Search tickets...',
        allStatus: 'All Status',
        allPriority: 'All Priority',
        allAssignees: 'All Assignees',
        resetFilters: 'Reset Filters'
      },
      
      table: {
        title: 'Title',
        status: 'Status',
        priority: 'Priority',
        assignee: 'Assignee',
        updated: 'Updated',
        created: 'Created at',
        unassigned: 'Unassigned'
      },
      
      status: {
        new: 'New',
        waiting: 'Waiting',
        assigned: 'Assigned',
        inProgress: 'In Progress',
        waitingCustomer: 'Waiting Customer',
        resolved: 'Resolved',
        closed: 'Closed'
      },
      
      priority: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical'
      },
      
      wizard: {
      title: 'Create New Ticket',
      steps: {
        basic: 'Basic Information',
        details: 'Details',
        technical: 'Technical Information',
        review: 'Review'
      },
      fields: {
        title: 'Ticket Title',
        titlePlaceholder: 'Briefly describe your problem',
        category: 'Category',
        selectCategory: 'Select a category',
        priority: 'Priority',
        selectPriority: 'Select priority',
        description: 'Detailed Description',
        descriptionPlaceholder: 'Describe your problem in detail...',
        motor: 'Motor',
        motorPlaceholder: 'Ex: C27, L46, etc.',
        configuration: 'Configuration',
        configurationPlaceholder: 'Ex: L4G, C27, etc.',
        component: 'Component',
        componentPlaceholder: 'Ex: Valves, Electrical system',
        partNumber: 'Part Number',
        partNumberPlaceholder: 'Ex: 12345-ABC-678'
      },
      categories: {
        diagnostic: 'Diagnostic',
        maintenance: 'Maintenance',
        repair: 'Repair',
        consultation: 'Consultation',
        other: 'Other'
      },
      actions: {
        next: 'Next',
        previous: 'Previous',
        submit: 'Create Ticket',
        cancel: 'Cancel',
        submitting: 'Creating...'
      },
      validation: {
        titleRequired: 'Title is required',
        titleMin: 'Title must be at least 10 characters',
        categoryRequired: 'Select a category',
        priorityRequired: 'Select a priority',
        descriptionRequired: 'Description is required',
        descriptionMin: 'Description must be at least 20 characters'
      },
      preview: {
        title: 'Review your Ticket',
        subtitle: 'Verify all information is correct before creating the ticket',
        basicInfo: 'Basic Information',
        technicalInfo: 'Technical Information',
        optional: 'Optional'
      },
      success: {
        created: 'Ticket created successfully',
        redirecting: 'Redirecting...'
      }
    },    
      
      
      detail: {
        backToTickets: 'Back to tickets',
        label: 'Label',
        assignedTo: 'Assigned to',
        dueDate: 'Due date',
        description: 'Description',
        comments: 'Comments',
        attachments: 'Attachments',
        activity: 'Activity',
        writeComment: 'Write comment',
        send: 'Send',
        noAttachments: 'No attachments yet',
        hasChange: 'has change',
        statusTo: 'status to',
        commentOnYour: 'comment on your',
        addedTags: 'added tags',
        addedDocument: 'added document',
        assignedTicket: 'assigned ticket',
        technicalInfo: 'Technical Information',
        configuration: 'Configuration',
        component: 'Component',
        partNumber: 'Part Number',
        noComments: 'No comments yet',
        ticketCreated: 'Ticket created',
        lastUpdate: 'Last updated',
        by: 'by'
      },
      time: {
        justNow: 'Just now', // ES
        ago: 'ago' // ES
        },
        pagation: {
        showing: 'Showing',
        of: 'of'
        },
      empty: {
        title: 'No tickets found',
        description: 'Try adjusting your search or filters'
      }, 
  
      actions: {
          edit: 'Edit',
          save: 'Save',
          saving: 'Saving...',
          cancel: 'Cancel',
          delete: 'Delete'
          },
          errors: {
          loadFailed: 'Error loading ticket',
          updateFailed: 'Error updating ticket',
          deleteFailed: 'Error deleting ticket'
          },
          success: {
          updated: 'Ticket updated successfully',
          deleted: 'Ticket deleted successfully'
          },
          confirm: {
          delete: 'Are you sure you want to delete this ticket?'
          }


    }
  
  },
  de: {
  // Dentro de translations.de:
chat: {
  title: "Technischer KI-Assistent",
  subtitle: "Spezialisiert auf Caterpillar-Ausrüstung",
  placeholder: "Geben Sie hier Ihre technische Anfrage ein...",
  thinking: "Verarbeitung...",
  error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  noResponse: "Keine gültige Antwort erhalten",
  hideHistory: "Verlauf ausblenden",
  showHistory: "Verlauf anzeigen",
  print: "Drucken",
  download: "Herunterladen",
  welcome: {
    hello: "Hallo {{name}}!",
    there: "da",
    subtitle: "Wie kann ich Ihnen heute helfen?"
  },
  
  suggestions: {
    expert: {
      title: "Fehlerdiagnose bei Geräten",
      description: "Technische Probleme und Lösungen identifizieren"
    },
    sales: {
      title: "Analyse der Betriebsleistung",
      description: "Optimierung von Caterpillar-Maschinen"
    },
    organized: {
      title: "Präventiver Wartungsplan",
      description: "Planung technischer Dienstleistungen"
    },
    code: {
      title: "Handbücher und Spezifikationen konsultieren",
      description: "Detaillierte technische Informationen"
    }
  },
  
  history: {
    title: "Anfrageverlauf",
    search: "Konversation suchen",
    empty: "Keine vorherigen Gespräche",
    newChat: "Neue Anfrage"
  }
  },
      tickets: {
      title: 'Tickets',
      hello: 'Hallo',
      subtitle: 'Hier sind die Dinge, die in Ihrem Support passieren',
      newTicket: 'Neues Ticket',
      locale: 'de',
      stats: {
        open: 'Offene Tickets',
        waiting: 'Warten auf Antwort',
        active: 'Aktive Tickets',
        resolved: 'Gelöste Tickets' 
      },
      
      filters: {
        search: 'Tickets suchen...',
        allStatus: 'Alle Status',
        allPriority: 'Alle Prioritäten',
        allAssignees: 'Alle Zugewiesenen',
        resetFilters: 'Filter zurücksetzen'
      },
      
      table: {
        title: 'Titel',
        status: 'Status',
        priority: 'Priorität',
        assignee: 'Zugewiesen',
        updated: 'Aktualisiert',
        created: 'Erstellt am',
        unassigned: 'Nicht zugewiesen'
      },
      
      status: {
        new: 'Neu',
        waiting: 'Wartend',
        assigned: 'Zugewiesen',
        inProgress: 'In Bearbeitung',
        waitingCustomer: 'Warten auf Kunde',
        resolved: 'Gelöst',
        closed: 'Geschlossen'
      },
      
      priority: {
        low: 'Niedrig',
        medium: 'Mittel',
        high: 'Hoch',
        critical: 'Kritisch'
      },
      
     wizard: {
      title: 'Neues Ticket erstellen',
      steps: {
        basic: 'Grundinformationen',
        details: 'Details',
        technical: 'Technische Informationen',
        review: 'Überprüfen'
      },
      fields: {
        title: 'Ticket-Titel',
        titlePlaceholder: 'Beschreiben Sie Ihr Problem kurz',
        category: 'Kategorie',
        selectCategory: 'Kategorie auswählen',
        priority: 'Priorität',
        selectPriority: 'Priorität auswählen',
        description: 'Detaillierte Beschreibung',
        descriptionPlaceholder: 'Beschreiben Sie Ihr Problem im Detail...',
        motor: 'Motor',
        motorPlaceholder: 'Z.B.: C27, L46, usw.',
        configuration: 'Konfiguration',
        configurationPlaceholder: 'Z.B.: L4G, C27, usw.',
        component: 'Komponente',
        componentPlaceholder: 'Z.B.: Ventile, Elektrisches System',
        partNumber: 'Teilenummer',
        partNumberPlaceholder: 'Z.B.: 12345-ABC-678'
      },
      categories: {
        diagnostic: 'Diagnose',
        maintenance: 'Wartung',
        repair: 'Reparatur',
        consultation: 'Beratung',
        other: 'Andere'
      },
      actions: {
        next: 'Weiter',
        previous: 'Zurück',
        submit: 'Ticket erstellen',
        cancel: 'Abbrechen',
        submitting: 'Erstellen...'
      },
      validation: {
        titleRequired: 'Titel ist erforderlich',
        titleMin: 'Titel muss mindestens 10 Zeichen lang sein',
        categoryRequired: 'Kategorie auswählen',
        priorityRequired: 'Priorität auswählen',
        descriptionRequired: 'Beschreibung ist erforderlich',
        descriptionMin: 'Beschreibung muss mindestens 20 Zeichen lang sein'
      },
      preview: {
        title: 'Überprüfen Sie Ihr Ticket',
        subtitle: 'Überprüfen Sie alle Informationen, bevor Sie das Ticket erstellen',
        basicInfo: 'Grundinformationen',
        technicalInfo: 'Technische Informationen',
        optional: 'Optional'
      },
      success: {
        created: 'Ticket erfolgreich erstellt',
        redirecting: 'Umleiten...'
      }
    },
      
      detail: {
        backToTickets: 'Zurück zu Tickets',
        label: 'Etikett',
        assignedTo: 'Zugewiesen an',
        dueDate: 'Fälligkeitsdatum',
        description: 'Beschreibung',
        comments: 'Kommentare',
        attachments: 'Anhänge',
        activity: 'Aktivität',
        writeComment: 'Kommentar schreiben',
        send: 'Senden',
        noAttachments: 'Noch keine Anhänge',
        hasChange: 'hat geändert',
        statusTo: 'Status zu',
        commentOnYour: 'kommentierte Ihren',
        addedTags: 'hat Tags hinzugefügt',
        addedDocument: 'hat Dokument hinzugefügt',
        assignedTicket: 'hat Ticket zugewiesen',
        technicalInfo: 'Technische Informationen',
        configuration: 'Konfiguration',
        component: 'Komponente',
        partNumber: 'Teilenummer',
        noComments: 'Noch keine Kommentare',
        ticketCreated: 'Ticket erstellt',
        lastUpdate: 'Zuletzt aktualisiert',
        by: 'von'
      },
       time: {
          justNow: 'Gerade eben', // ES
          ago: 'vor' // ES
        },
        pagination: {
          showing: 'Wird angezeigt',
          of: 'von'
        },
      empty: {
        title: 'Keine Tickets gefunden',
        description: 'Versuchen Sie, Ihre Suche oder Filter anzupassen'
      },
       actions: {
          edit: 'Bearbeiten',
          save: 'Speichern',
          saving: 'Speichern...',
          cancel: 'Abbrechen',
          delete: 'Löschen'
          },
          errors: {
          loadFailed: 'Fehler beim Laden des Tickets',
          updateFailed: 'Fehler beim Aktualisieren des Tickets',
          deleteFailed: 'Fehler beim Löschen des Tickets'
          },
          success: {
          updated: 'Ticket erfolgreich aktualisiert',
          deleted: 'Ticket erfolgreich gelöscht'
          },
          confirm: {
          delete: 'Möchten Sie dieses Ticket wirklich löschen?'
          }
    }
  }

};

// ================================================================
// 🎯 TIPOS E INTERFACES
// ================================================================
interface I18nContextType {
  language: string;
  changeLanguage: (newLanguage: string) => Promise<void>;
  t: (key: string, params?: Record<string, any>) => string;
  availableLanguages: string[];
  isLoading: boolean;
}

interface I18nProviderProps {
  children: ReactNode;
  defaultLanguage?: string;
}

// ================================================================
// 🔧 CONTEXTO DE INTERNACIONALIZACIÓN
// ================================================================
const I18nContext = createContext<I18nContextType | undefined>(undefined);

// ================================================================
// 🌍 PROVIDER PRINCIPAL
// ================================================================
export const I18nProvider: React.FC<I18nProviderProps> = ({ 
  children, 
  defaultLanguage = 'es' 
}) => {
  const [language, setLanguage] = useState<string>(defaultLanguage);
  const [isLoading, setIsLoading] = useState(false);
  
  const availableLanguages = ['es', 'en'];

  // 🔄 Función para traducir con interpolación
  const t = (key: string, params: Record<string, any> = {}): string => {
    const keys = key.split('.');
    let value: any = translations[language as keyof typeof translations];
    
    // Navegar por la estructura de claves
    for (const k of keys) {
      value = value?.[k];
    }
    
    // Si no se encuentra la traducción, intentar en español como fallback
    if (!value && language !== 'es') {
      let fallbackValue: any = translations.es;
      for (const k of keys) {
        fallbackValue = fallbackValue?.[k];
      }
      value = fallbackValue;
    }
    
    // Si aún no hay valor, retornar la clave
    if (!value) {
      console.warn(`🌍 [I18N] Translation missing for key: ${key} in language: ${language}`);
      return key;
    }
    
    // Interpolación de parámetros {{variable}}
    if (typeof value === 'string' && Object.keys(params).length > 0) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, param) => {
        return params[param]?.toString() || match;
      });
    }
    
    return value;
  };

  // 🔄 Cambiar idioma con notificación al backend
  const changeLanguage = async (newLanguage: string): Promise<void> => {
    if (newLanguage === language || !availableLanguages.includes(newLanguage)) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      // 📡 Notificar al backend del cambio de idioma
      const response = await fetch('/api/language', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ language: newLanguage })
      });
      
      if (response.ok) {
        setLanguage(newLanguage);
        
        // 💾 Guardar preferencia en localStorage
        localStorage.setItem('preferred_language', newLanguage);
        
        // 🌐 Cambiar idioma del documento HTML
        document.documentElement.lang = newLanguage;
        
        // 🔄 Disparar evento para notificar cambio
        window.dispatchEvent(new CustomEvent('languageChanged', { 
          detail: { language: newLanguage } 
        }));
        
        console.log(`🌍 [I18N] Language changed to: ${newLanguage}`);
        
      } else {
        throw new Error('Failed to change language on server');
      }
    } catch (error) {
      console.error('🌍 [I18N] Error changing language:', error);
      // En caso de error del servidor, cambiar localmente
      setLanguage(newLanguage);
      localStorage.setItem('preferred_language', newLanguage);
    } finally {
      setIsLoading(false);
    }
  };

  // 🚀 Inicializar idioma desde localStorage al cargar
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred_language');
    if (savedLanguage && availableLanguages.includes(savedLanguage) && savedLanguage !== language) {
      setLanguage(savedLanguage);
      document.documentElement.lang = savedLanguage;
      console.log(`🌍 [I18N] Loaded saved language: ${savedLanguage}`);
    }
  }, []);

  const contextValue: I18nContextType = {
    language,
    changeLanguage,
    t,
    availableLanguages,
    isLoading
  };

  return React.createElement(
    I18nContext.Provider,
    { value: contextValue },
    children
  );
};

// ================================================================
// 🎣 HOOK PARA USAR EN COMPONENTES
// ================================================================
export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};

